import { EntityType } from '@frontend/common';
import { Functionality } from '@frontend/functionality/types';
import { IMAGE_MIME_TYPES, useBlobRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

export async function getFunctionalityBlobImage(
    blobRepository: ReturnType<typeof useBlobRepository>,
    functionality: Pick<Functionality, 'id' | 'account_id'>
): Promise<string | null> {
    const info = await blobRepository.getBlob(functionality.account_id, EntityType.FUNCTIONALITY, functionality.id);
    if (info && (!info.mimeType || IMAGE_MIME_TYPES.includes(info.mimeType))) return info.url;
    return null;
}

/** Returns the functionality blob image URL when present; otherwise null (fall back to icon). */
export function useFunctionalityBlobImage(functionality: Pick<Functionality, 'id' | 'account_id'> | null | undefined): string | null {
    const blobRepository = useBlobRepository();
    const [url, setUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!functionality?.id || !functionality.account_id) {
            setUrl(null);
            return;
        }

        let cancelled = false;
        getFunctionalityBlobImage(blobRepository, functionality)
            .then((imageUrl) => {
                if (!cancelled) setUrl(imageUrl);
            })
            .catch(() => {
                if (!cancelled) setUrl(null);
            });

        return () => {
            cancelled = true;
        };
        // blobRepository is a stable store API; omit from deps to avoid refetch on provider re-renders
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [functionality?.account_id, functionality?.id]);

    return url;
}
